//GET OR INITIALIZE EHDI
var EHDI = EHDI || Object.create(null);

EHDI.UpdateManager = function(renderer, stage) {
  this._autoRender;
  this._updateList;
  this._ticker;
  this._bindUpdate;
  this._currentFPS;

  this._autoRender = false;
  this._updateList = [];
  this._currentFPS = 60;

  this.update();

  if (this._bindUpdate == null) {
    this._bindUpdate = this.update.bind(this);
  }

  if (this._ticker == null) {
    this._ticker = new EHDI.aka.Ticker();
    this._ticker.add(this._bindUpdate);
  }

	if(arguments.length > 0) {
		if(!(renderer instanceof EHDI.aka.CanvasRenderer) && !(renderer instanceof EHDI.aka.GLRenderer))
      throw new Error("Please pass renderer as parameter");

    if(!(stage instanceof EHDI.aka.DisplayObject))
      throw new Error("Stage is not a display object");

		this._autoRender = true;
		this._renderer = renderer;
		this._stage = stage;
	}

  this._ticker.start();
};

EHDI.UpdateManager.prototype.update = function (e) {
  this._updateSkipCount = 0;
  if(this._updateList.length > 0){
    for(var i = 0; i < this._updateList.length; i++){
      this._updateList[i](e);
    }
  }

  if(this._autoRender) this._renderer.render(this._stage);
};

EHDI.UpdateManager.prototype.getFPS = function () {
  if (this._currentFPS != this._ticker.FPS)
    this._currentFPS = this._ticker.FPS;

  return Math.ceil(this._currentFPS);
};

EHDI.UpdateManager.prototype.setAutoRender = function (autoRender) {
  if(typeof autoRender !== 'bool') throw new Error("Parameter must be a boolean");

  this._autoRender = autoRender;
};

EHDI.UpdateManager.prototype.isAutoRendering = function () {
  return this._autoRender;
};

EHDI.UpdateManager.prototype.addFrameListener = function (callback) {
  if(typeof callback !== 'function') throw new Error("Callback must be a function");

  this._updateList.push(callback);
};

EHDI.UpdateManager.prototype.removeFrameListener = function (callback) {
  if(typeof callback !== 'function') throw new Error("Callback must be a function");

  var index = this._updateList.indexOf(callback);
  if(index > -1) this._updateList.splice(index, 1);
};

EHDI.UpdateManager.prototype.hasFrameListener = function (callback) {
  if(typeof callback !== 'function') throw new Error("Callback must be a function");

  if(this._updateList.indexOf(callback) > -1) return true;
  else return false;
};

EHDI.UpdateManager.prototype.removeAllFrameListeners = function () {
  while (this._updateList.length > 0) {
    this._updateList.pop();
  }

  this._updateList = [];
};
